/*
 * Variant Image Filter
 * Works WITH the built-in Impulse image set feature, extending it to support:
 * - Single-variant images: #options_crop-baby-tee-black
 * - Multi-variant images:  #options_crop-baby-tee-black+soft-premium-tee-black
 * - Shared images:         (no # tag in alt text — always visible)
 *
 * Approach: Intercepts variant selection clicks BEFORE the theme's handler
 * reads data-group attributes, updating shared/multi-variant slides to match
 * the incoming variant. The built-in cellSelector then naturally includes them.
 *
 * THEME UPDATE NOTE:
 * If theme is updated, re-add this line to layout/theme.liquid before </body>:
 *   <script src="{{ 'variant-image-filter.js' | asset_url }}" defer></script>
 */

(function() {
  'use strict';

  // ====== CONFIG ======
  var FILTER_OPTION_NAME = 'options'; // handleized option name to filter by

  // ====== HELPERS ======
  function handleize(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  }

  var prefix = FILTER_OPTION_NAME + '_';

  function isMultiVariant(group) {
    if (!group) return false;
    var value = group.indexOf(prefix) === 0 ? group.slice(prefix.length) : group;
    return value.indexOf('+') !== -1 || value.indexOf('*') !== -1;
  }

  function matchesVariant(group, normalizedValue) {
    if (!group) return false;
    var value = group.indexOf(prefix) === 0 ? group.slice(prefix.length) : group;
    var parts = value.split('+');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      if (part.indexOf('*') !== -1) {
        // Wildcard: "crop-baby-tee*" matches any value starting with "crop-baby-tee"
        var pattern = part.replace(/\*/g, '');
        if (normalizedValue.indexOf(pattern) === 0) return true;
      } else {
        if (part === normalizedValue) return true;
      }
    }
    return false;
  }

  // ====== INITIALIZATION ======
  // Run as early as possible — don't wait for DOMContentLoaded for setup
  // but do wait for DOM to query elements
  function init() {
    var container = document.querySelector('[data-product-photos]');
    var thumbContainer = document.querySelector('[data-product-thumbs]');
    if (!container || !container.querySelector('[data-group]')) return;

    // Fix: Flickity's cellSelector reorders DOM on destroy/recreate.
    // When Flickity activates with cellSelector, only matching slides move into
    // the slider wrapper. On destroy(), they're appended AFTER non-matching slides,
    // scrambling the original Shopify media order. This patch sorts filtered cells
    // by data-index to restore the correct order every time Flickity initializes.
    // Flickity must be loaded via vendor-scripts before this script (see layout/theme.liquid)
    if (typeof Flickity !== 'undefined' && !Flickity.prototype._sortPatchApplied) {
      var origFilter = Flickity.prototype._filterFindCellElements;
      Flickity.prototype._filterFindCellElements = function(elements) {
        var result = origFilter.call(this, elements);
        if (this.options.cellSelector) {
          result.sort(function(a, b) {
            var aIdx = parseInt(a.getAttribute('data-index'), 10);
            var bIdx = parseInt(b.getAttribute('data-index'), 10);
            if (isNaN(aIdx) || isNaN(bIdx)) return 0;
            return aIdx - bIdx;
          });
        }
        return result;
      };
      Flickity.prototype._sortPatchApplied = true;
    }

    // Collect special slides (shared + multi-variant)
    var specialSlides = [];
    var specialThumbs = [];

    container.querySelectorAll('.product-main-slide').forEach(function(slide) {
      var group = slide.getAttribute('data-group');
      if (!group) {
        // Shared: needs data-group and data-set-name added
        specialSlides.push({ el: slide, type: 'shared', original: null });
        slide.setAttribute('data-set-name', FILTER_OPTION_NAME);
      } else if (isMultiVariant(group)) {
        specialSlides.push({ el: slide, type: 'multi', original: group });
      }
    });

    if (thumbContainer) {
      thumbContainer.querySelectorAll('.product__thumb-item').forEach(function(thumb) {
        var group = thumb.getAttribute('data-group');
        if (!group) {
          specialThumbs.push({ el: thumb, type: 'shared', original: null });
          thumb.setAttribute('data-set-name', FILTER_OPTION_NAME);
        } else if (isMultiVariant(group)) {
          specialThumbs.push({ el: thumb, type: 'multi', original: group });
        }
      });
    }

    // Nothing special to manage — built-in system handles everything
    if (specialSlides.length === 0 && specialThumbs.length === 0) return;

    function updateGroups(normalizedValue) {
      var target = prefix + normalizedValue;

      specialSlides.forEach(function(item) {
        if (item.type === 'shared') {
          item.el.setAttribute('data-group', target);
        } else {
          // Multi-variant: match → use target, no match → restore original
          item.el.setAttribute('data-group',
            matchesVariant(item.original, normalizedValue) ? target : item.original
          );
        }
      });

      specialThumbs.forEach(function(item) {
        if (item.type === 'shared') {
          item.el.setAttribute('data-group', target);
        } else {
          item.el.setAttribute('data-group',
            matchesVariant(item.original, normalizedValue) ? target : item.original
          );
        }
      });
    }

    // ====== INITIAL STATE ======
    // Read current variant and apply data-groups before theme.js inits
    var currentVariantEl = document.querySelector('[data-current-variant-json]');
    var variantJsonEl = document.querySelector('[data-variant-json]');
    var optionIndex = 'option1';

    // Find the option index for our filter option
    var productJsonEl = document.querySelector('[data-product-json]');
    if (productJsonEl) {
      try {
        var product = JSON.parse(productJsonEl.textContent);
        if (product.options) {
          for (var i = 0; i < product.options.length; i++) {
            if (handleize(product.options[i]) === FILTER_OPTION_NAME) {
              optionIndex = 'option' + (i + 1);
              break;
            }
          }
        }
      } catch (e) { /* ignore */ }
    }

    // Get initial variant value
    var initialValue = null;
    if (currentVariantEl) {
      try {
        var cv = JSON.parse(currentVariantEl.textContent);
        if (cv && cv[optionIndex]) initialValue = handleize(cv[optionIndex]);
      } catch (e) { /* ignore */ }
    }
    if (!initialValue && variantJsonEl) {
      try {
        var variants = JSON.parse(variantJsonEl.textContent);
        if (variants && variants.length > 0 && variants[0][optionIndex]) {
          initialValue = handleize(variants[0][optionIndex]);
        }
      } catch (e) { /* ignore */ }
    }

    if (initialValue) {
      updateGroups(initialValue);
    }

    // ====== INTERCEPT VARIANT CLICKS ======
    // Use capture phase so we run BEFORE the theme's handlers
    // This ensures data-groups are updated before the theme reads them

    // Handle radio buttons (swatch-style variant selectors)
    document.addEventListener('click', function(evt) {
      var radio = evt.target.closest('input[type="radio"]');
      if (!radio) return;

      var fieldset = radio.closest('[data-handle="' + FILTER_OPTION_NAME + '"]');
      if (!fieldset) return;

      // This radio belongs to our filter option — update groups
      updateGroups(handleize(radio.value));
    }, true); // capture phase

    // Handle select dropdowns (dropdown-style variant selectors)
    document.addEventListener('change', function(evt) {
      var select = evt.target;
      if (select.tagName !== 'SELECT') return;

      var wrapper = select.closest('[data-handle="' + FILTER_OPTION_NAME + '"]');
      if (!wrapper) return;

      updateGroups(handleize(select.value));
    }, true); // capture phase

    // Also listen for variant:change as a safety net (for programmatic changes)
    document.addEventListener('variant:change', function(evt) {
      if (!evt.detail || !evt.detail.variant) return;
      var value = evt.detail.variant[optionIndex];
      if (value) {
        updateGroups(handleize(value));
      }
    });
  }

  // Run init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
